module.exports = __webpack_public_path__ + "static/img/marok.08f9e507.webp";